import gsap from "gsap";

(function ($) {
    $(document).ready(function () {

        const time = 8000, speed = 500, progressBarLine = $(".progress-bar .line");

        function initSlider() {

            const swiperOptions = {
                loop: true,
                spaceBetween: 40,
                slidesPerView: 1,
                allowTouchMove: false,
                pagination: {
                    el: ".section-testimonial_slider .swiper-pagination",
                    type: "progressbar",
                },
                navigation: {
                    nextEl: ".slider-navigation .next",
                    prevEl: ".slider-navigation .prev",
                },
                autoplay: {
                    delay: time,
                    disableOnInteraction: false
                },
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                speed: speed,
                on: {
                    slideChange: () => progressBar()
                }
            };

            const slider = new Swiper(".testimonial-slider", swiperOptions);
        }

        //progress bar
        const progressBar = () => {
            gsap.fromTo(progressBarLine, {
                scaleX: 0
            }, {
                scaleX: 100 + "%",
                ease: "none",
                duration: (time + speed) / 1000
            })
        }

        initSlider();
    })
})(jQuery);
